<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>

<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">Sports</h1>
      <ul>
        <li><a class="active" routerLink="/">Home</a></li>
        <li><a>Infrastructure</a></li>
        <li>Sports</li>
      </ul>
    </div>
  </div>

  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70 infrastructure-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <infra-menu></infra-menu>
        </div>

        <div class="col-lg-8">
          <div class="row">
            <div class="col-lg-12 mb-70">
              <div class="blog-item">
                <div class="blog-content">
                  <h3 class="blog-title">Sports</h3>
                  <p class="infrastructure-text">Sports facilities promote physical well-being and help students develop discipline and leadership.</p>

                  <div class="rs-gallery">
                    <div class="container">
                      <div class="row">
                        <div class="col-lg-6 mb-30 col-md-6">
                          <div class="gallery-item">
                            <div class="gallery-img">
                              <a class="image-popup" href="assets/college/pics/FOOTBALL.jpg"><img src="assets/college/pics/FOOTBALL.jpg" alt="Sports - View 1"></a>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 mb-30 col-md-6">
                          <div class="gallery-item">
                            <div class="gallery-img">
                              <a class="image-popup" href="assets/college/pics/RUBBY 1.jpg"><img src="assets/college/pics/RUBBY 1.jpg" alt="Sports - View 1"></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->

